import React from 'react';
import { useAuth } from 'react-oidc-context';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { useSessionFeatureState } from '@hooks/storeHooks/useSessionState';
import { IdleModal } from './components/IdleModal';
import { Reminder } from './components/Reminder';
import SessionContainer from './components/SessionContainer';
import { useBallance } from './hooks/useBallance';

const AvatarSession: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const startParam = searchParams.get('start');

  const { isAuthenticated, isLoading: isAuthLoading } = useAuth();
  const { companionSlug, transcriptTime } = useSessionFeatureState();

  const onZeroBalance = () => {
    if (startParam === 'true') {
      navigate(location.pathname);
    }
  };

  useBallance({
    onZeroBalance,
  });

  if (!companionSlug || !isAuthenticated || isAuthLoading) {
    return null;
  }

  return (
    <>
      <SessionContainer />
      {transcriptTime !== null && <IdleModal transcriptTime={transcriptTime} />}
      <Reminder />
    </>
  );
};

export default AvatarSession;
